import React, { useEffect, useState, useRef } from 'react';
import swal from 'sweetalert2';
import ImageCropper from '../components/global/imageCropper';
import * as helper from '../components/global/helper';

const imgUrl = 'https://metromatrix.s3.ap-south-1.amazonaws.com/Public/MatroMatrix/Content/';

import { getEmployeeList, postEmployee } from './api/employeeAPI';
import { uploadPublicFile } from './api/fileAPI';
import { getAuthState } from '../assets/scripts/login-util';
import EmptyView from './global/emptyView';

const Employee = (props) => {

    const [auth,                setAuth]                = useState(getAuthState('user'));

    const [employees,         setEmployees]             = useState([]);
    const [filteredEmployees, setFilteredEmployees]     = useState([]);

    const [employee,          setEmployee]              = useState({ID: 0, Active: 'Y'});
    const [showPassword,      setShowPassword]          = useState(false);
    const [validated,         setValidated]             = useState(false);

    const [selectedImage,     setSelectedImage]         = useState(null);
    const [croppedImage,      setCroppedImage]          = useState(null);   
    const fileInputRef        = useRef(null);

    

    useEffect(() => {
        fetchEmployees();
        const modalElement = document.getElementById('addModal');
        const handleModalHide = () => resetData();
        modalElement.addEventListener('hidden.bs.modal', handleModalHide);
        return () => {
            modalElement.removeEventListener('hidden.bs.modal', handleModalHide);
        };
    }, [])

    const fetchEmployees = async() => {
        try {
            swal.fire({
                titleText           : 'Loading',
                text                : 'Please Wait...',
                showConfirmButton   : false,
                allowOutsideClick   : false,
                didOpen: () => {
                    swal.showLoading();
                }
            });
            const { Employees } = await getEmployeeList();
            setEmployees(Employees);
            setFilteredEmployees(Employees);
            swal.close();
        } catch (err) {
            swal.close();
            swal.fire({ icon: "error", titleText: "Error!", text: err.message });
            return;  
        }
    }

    const postEmployeeData = async(e)=> {
        e.preventDefault();
        const form = e.currentTarget;
        if (form.checkValidity() === false) {     
            e.stopPropagation();
            setValidated(true);
        }else{
            try {
                swal.fire({
                    titleText           : 'Loading',
                    text                : 'Please Wait...',
                    showConfirmButton   : false,
                    allowOutsideClick   : false,
                    didOpen: () => {
                        swal.showLoading();
                    }
                });

                let photo = employee.Photo ? employee.Photo : '';
                if(croppedImage){
                    const res = await uploadPublicFile(croppedImage, 'Content');
                    photo = res.FileName;
                }

                await postEmployee({...employee, Photo: photo});
                await fetchEmployees();
                document.querySelector('#addModal .btn-close').click();

                swal.close();

                if (employee.ID) {
                    swal.fire({
                        icon: 'success',
                        title: '<small>Employee updated successfully!</small>',
                        showConfirmButton: false,
                        timer: 1500,
                    });
                }else {
                    swal.fire({
                        icon: 'success',
                        title: '<small>Employee added successfully!</small>',
                        showConfirmButton: false,
                        timer: 1500,
                    });
                }
          
            } catch (err) {
                swal.close();
                swal.fire({
                    icon              : "error",
                    titleText         : "Error!",
                    text              : err.message
                  })
                return;  
            }
        }    
    }

    const onEmployeeSearch = (searchTerm) => {
        if(!searchTerm || searchTerm === '') return setFilteredEmployees(employees);

        //filter as per searched
        const filtered = employees.filter(m => {
            let matchString = `${m.Name} ${m?.Email} ${m.Contact}`;
            let matchFound  = 0;
            var searchArr   = searchTerm.split(' ');
            
            searchArr.forEach(t => matchFound += matchString.toLowerCase().includes(t.toLowerCase()) ? 1 : 0);

            return matchFound === searchArr.length;
        });
        
        setFilteredEmployees(filtered);
    };
    
    const handleData = (key, value)=>{
        setEmployee((d)=> { return {...d, [key] : value} });
    };

    const resetData = () => {
        setEmployee({ID: 0, Active: 'Y'});
        setShowPassword(false);
        setCroppedImage(null);
        setValidated(false);
        fileInputRef.current.value = null;
    };
    
    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
          const reader = new FileReader();
          reader.onload = () => {
            setSelectedImage(reader.result);
          };
          reader.readAsDataURL(file);
        }
    };
    
      const handleCropComplete = (croppedImg, type) => {
        setCroppedImage(croppedImg);
        setSelectedImage(null);
        fileInputRef.current.value = null; 
      };

      const handleCropCancel = () => {
        setSelectedImage(null);
      };

      

    return ( 
        <>
            <div className="navbar navbar-expand-lg fixed-top margin-t58" style={{backgroundColor: '#fff', zIndex: '1'}}>
                <div className="container d-block padding-t10" style={{height: '60px'}}>
                    <div className='row mb-4'>
                        <div className='col-12'>
                            <div className='input-group'>
                                <span className='input-group-text fs-16'><i className="bi bi-search"></i></span>
                                <input 
                                    className="form-control fs-16" 
                                    type="search" 
                                    placeholder="Search"
                                    onChange={({target}) => onEmployeeSearch(target.value)}
                                />
                            </div>
                        </div>      
                    </div>
                </div>
            </div>

            <div className='container margin-t150'>  
                <div className='row'>
                    {filteredEmployees.length > 0 ? filteredEmployees.map((m, i) => (
                        <div className='col-lg-6' key={m.ID}>  
                            <div className="card mb-4" data-bs-toggle="modal" data-bs-target="#addModal" onClick={() => setEmployee(m)}>
                                <div className="card-body d-flex justify-content-between align-items-center">
                                    <div className='flex-shrink-0'>
                                        {m.Photo && m.Photo != '' ?
                                            <img src={`${imgUrl}${m.Photo}`} alt="image" className="rounded-circle" width="70" height="70"/> :
                                            <div className="initial-circle-tpa me-2">
                                                {m.Name[0]}
                                            </div>
                                        }                                           
                                    </div>
                                    <div className="ms-3 flex-grow-1">
                                        <h6 className="card-title mb-1">{m.Name}</h6>
                                        <span className='card-text fs-16'>
                                            <span><i className="bi bi-telephone text-primary"></i> {m.Contact}</span><br/>
                                            <span><i className="bi bi-envelope text-primary"></i> {m.Email}</span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )) : (
                        <EmptyView message={'No Employees!'}/>
                    )}                           
                </div>
            </div>

            <div id='addModal' className="modal modal-lg fade" tabIndex="-1" aria-labelledby="modalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
                <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h6 className="modal-title" id="modalLabel">{(!employee.ID || employee.ID == 0) ? 'Add' : 'Update'} Employee</h6>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true"></span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                <form id='employeeForm' className={`row mt-3 needs-validation ${validated ? "was-validated" : ""}`} noValidate onSubmit={postEmployeeData}>
                                    <div className='col-md-6 mb-3'>
                                        <div className="form-floating">
                                            <input 
                                                onChange={({ target }) => handleData('Name', helper.camelCase(target.value))}
                                                value={ employee.Name || '' }
                                                id="txtName" 
                                                type="text" 
                                                className="form-control" 
                                                placeholder='Name' 
                                                required
                                            />
                                            <label htmlFor="txtName">Name</label>
                                            <div className="invalid-feedback">Please enter name</div>
                                        </div>
                                    </div>
                                    <div className='col-md-6 mb-3'>
                                        <div className="form-floating">
                                            <input
                                                onChange={({ target }) => handleData('Email', helper.email(target.value))}
                                                value={ employee.Email || '' }
                                                id="txtEmail" 
                                                type="email" 
                                                className="form-control" 
                                                placeholder='Email'
                                                required 
                                            />
                                            <label htmlFor="txtEmail">Email</label>
                                            <div className="invalid-feedback">Please enter email</div>
                                        </div>
                                    </div>
                                    <div className='col-md-6 mb-3'>
                                        <div className="form-floating">
                                            <input 
                                                onChange={({ target }) => handleData('Contact', helper.contact(target.value))}
                                                value={ employee.Contact || '' }
                                                id="txtContactNo" 
                                                type="text"
                                                className="form-control" 
                                                placeholder='Contact No' 
                                                required
                                            />
                                            <label htmlFor="txtContactNo">Contact No</label>
                                            <div className="invalid-feedback">Please enter contact no.</div>
                                        </div>
                                    </div>
                                    
                                    {(employee && employee.ID > 0 && employee.IsAdmin == 'Y' && auth.isAdmin == 'N') ? '' : (
                                        <>
                                            <div className='col-md-6 mb-3'>
                                                <div className="form-floating">
                                                    <input
                                                        onChange={({ target }) => handleData('Password', target.value)}
                                                        value={ employee.Password || '' }
                                                        id="txtPassword" 
                                                        type={showPassword ? 'text' : 'password'}
                                                        className="form-control" 
                                                        placeholder='Password' 
                                                        required
                                                    />
                                                    <label htmlFor="txtPassword">Password</label>
                                                    <div className="invalid-feedback">Please enter password</div>
                                                    <span
                                                        className='password-toggle'
                                                        onClick={togglePasswordVisibility}>
                                                        {showPassword ? <i className="bi bi-eye"></i> : <i className="bi bi-eye-slash"></i>}
                                                    </span>
                                                </div>
                                            </div>  
                                            <div className='col-12 mb-3'>
                                                <div className='d-flex justify-content-between align-items-center'>
                                                    <input 
                                                        ref={fileInputRef}
                                                        className="form-control d-none" 
                                                        type="file" 
                                                        id="filePhoto"
                                                        accept=".png, .jpeg, .jpg"
                                                        onChange={handleFileChange}
                                                    />
                                                    <label htmlFor="filePhoto" className="form-control d-flex justify-content-between align-items-center file-uploader">
                                                        <span>{(!!croppedImage || employee.Photo)  ? "Change Photo" : "Upload Photo"}</span>
                                                        <span className="upload-icon" style={{ marginLeft: 'auto' }}>
                                                            <i className="bi bi-upload"></i>
                                                        </span>
                                                    </label>
                                                    {(!!croppedImage || employee.Photo) && (
                                                        <>
                                                            <a type="button" href={croppedImage ? URL.createObjectURL(croppedImage) : `${imgUrl}${employee.Photo}`} target='_blank' className="btn btn-primary ms-2">View</a>
                                                            <button type="button" onClick={() => {setCroppedImage(null); handleData('Photo', '')}} className="btn btn-secondary ms-2">Remove</button>
                                                        </>
                                                    )}
                                                </div>
                                            </div>   
                                            <div className='col-md-12 mb-3'>
                                                <div className="form-check form-switch d-flex justify-content-center align-items-center">
                                                    <label className="me-5 pe-2 mb-0">Active</label>
                                                    <input 
                                                        className="form-check-input switch me-5" 
                                                        type="checkbox" 
                                                        defaultChecked={employee.Active == 'N' ? '' : 'checked'}
                                                        onChange={(event) => handleData('Active', event.target.checked ? 'Y' : 'N')} 
                                                    />
                                                </div>
                                            </div>
                                        </>
                                    )}                               
                                </form>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                            {(employee && employee.ID > 0 && employee.IsAdmin == 'Y' && auth.isAdmin == 'N') ? '' : (
                                <button type="submit" form='employeeForm' className="btn btn-primary">Save</button>
                            )}
                            
                        </div>
                    </div>
                </div>
            </div>

            {selectedImage && (
                <div className="cropper-overlay">
                    <ImageCropper 
                        image={selectedImage}
                        type={'Photo'}
                        dimension={{width: 250, height: 250}}
                        onCropComplete={handleCropComplete}
                        onCropCancel={handleCropCancel}
                    />
                </div>
            )}

        </>
    )

}

export default Employee;